// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"340":"c5701e54","399":"f6bee88e","499":"f8571e9f","629":"7fc21997","704":"f9c3906f","708":"b0dc3c4a","752":"ec364479","808":"853d5dc2"}[chunkId] + ".chunk.css";
};